import { INamespace } from '../database/interface';
import { IViolation } from '../base/annotation';

export interface IRelationship {
    name: string;
    namespace: INamespace;
    objectId?: string;
    objectVersion?: number;
    description?: string;
    fromTableName: string;
    toTableName: string;
    relationshipType: RelationshipType;
    columnRelationshipInformations: IColumnRelationshipInformation[];
    properties?: {
        derivedModelRelationshipInfo?: IDerivedModelRelationshipInfo;
    };
    violations?: IViolation[];
    newValidation?: boolean;
}

export enum RelationshipType {
    ONETOONE,
    ONETOMANY,
    MANYTOONE,
    MANYTOMANY
}

export interface IColumnRelationshipInformation {
    fromColumnName: string;
    toColumnName: string;
}

export interface IDerivedModelRelationshipInfo {
    baseRelationship: {
        fromEntity: string;
        toEntity: string;
        joinPairs?: IJoinPair[];
        name?: string;
    };
}

export interface IJoinPair {
    fromAttribute: string;
    toAttribute: string;
}
